(function () {
  'use strict';

  // Populated at page-load from the inline Liquid script in theme.liquid.
  // Also extended at runtime from _min_qty line item properties.
  var minQtyMap = Object.assign({}, window.__psMinQtyMap || {});
  var cartItems = [];

  async function refreshCart() {
    try {
      var data = await fetch('/cart.js').then(function (r) { return r.json(); });
      cartItems = data.items || [];
      // Extend map from _min_qty line item properties (set by buy-button.liquid)
      cartItems.forEach(function (item) {
        var minQty = item.properties && item.properties['_min_qty'];
        if (minQty) minQtyMap[String(item.variant_id)] = parseInt(minQty, 10);
      });
    } catch (_) {}
  }

  // ── PRIMARY: intercept window.fetch ──────────────────────────────────────
  // UpCart's JS runs in the main document scope, so it calls our wrapped fetch.
  // We correct any quantity below the minimum before the request reaches Shopify.

  function resolveVariantId(body) {
    if (body.id) {
      var s = String(body.id);
      return s.indexOf(':') !== -1 ? s.split(':')[0] : s;
    }
    if (body.line) {
      var item = cartItems[parseInt(body.line, 10) - 1];
      return item ? String(item.variant_id) : null;
    }
    return null;
  }

  var _fetch = window.fetch;
  window.fetch = async function (input, init) {
    var url =
      typeof input === 'string' ? input
      : input instanceof URL ? input.href
      : (input && input.url) || '';

    if (url.indexOf('/cart/change') !== -1 && init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        if (body.quantity !== undefined) {
          var vid = resolveVariantId(body);
          var minQty = vid ? minQtyMap[vid] : null;
          if (minQty && body.quantity > 0 && body.quantity < minQty) {
            init = Object.assign({}, init, {
              body: JSON.stringify(Object.assign({}, body, { quantity: minQty })),
            });
          }
        }
      } catch (_) {}
    }

    var result = await _fetch.apply(this, [input, init]);

    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/add') !== -1) {
      refreshCart();
    }

    return result;
  };

  // ── SECONDARY: block the click for immediate UI feedback ──────────────────
  // UpCart renders inside an open Shadow DOM. event.target is retargeted to the
  // shadow host, so we must use event.composedPath() to reach the actual button.

  function getTileRoot(btn) {
    var qSel = btn.parentElement;
    if (!qSel) return null;
    var cls = [].slice.call(qSel.classList).find(function (c) {
      return c.indexOf('__quantity-selector') !== -1;
    });
    if (!cls) return null;
    return btn.closest('[class~="' + cls.replace('__quantity-selector', '') + '"]');
  }

  function getVariantId(tile) {
    if (!tile) return null;
    // Extract from product link: href="/products/handle?variant=123456"
    var link = tile.querySelector('a[href*="variant="]');
    if (link) {
      var m = link.href.match(/[?&]variant=(\d+)/);
      if (m) return m[1];
    }
    // Positional fallback: <li> index in parent <ul>
    if (cartItems.length) {
      var li = tile.closest('li');
      var ul = li && li.parentElement;
      if (ul) {
        var idx = [].indexOf.call(ul.children, li);
        if (idx !== -1 && idx < cartItems.length) return String(cartItems[idx].variant_id);
      }
    }
    return null;
  }

  function getCurrentQty(btn) {
    var container = btn.parentElement;
    if (!container) return null;
    var children = [].slice.call(container.children);
    var minusIdx = children.indexOf(btn);
    for (var i = minusIdx + 1; i < children.length; i++) {
      var el = children[i];
      var hasPlus = [].slice.call(el.classList).some(function (c) { return c.indexOf('plus') !== -1; });
      if (hasPlus) break;
      var text = el.tagName === 'INPUT' ? el.value : el.textContent.trim();
      var qty = parseInt(text, 10);
      if (!isNaN(qty)) return qty;
    }
    return null;
  }

  function onMinusClick(event) {
    // composedPath() returns the full path including elements inside shadow roots
    var path = event.composedPath ? event.composedPath() : [];
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el.classList && el.classList.contains('upcart-public-component-product-tile__quantity-minus')) {
        btn = el;
        break;
      }
    }
    if (!btn) return;

    var tile = getTileRoot(btn);
    var vid = getVariantId(tile);
    var minQty = vid ? minQtyMap[vid] : null;
    var currentQty = getCurrentQty(btn);

    if (minQty && currentQty !== null && currentQty <= minQty) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  function init() {
    refreshCart();
    document.addEventListener('click', onMinusClick, true);

    ['upcart:cartUpdated', 'upcart:updated', 'cart:refresh', 'cart:updated'].forEach(function (evt) {
      document.addEventListener(evt, refreshCart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
